var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42738 18.0001C5.12593 17.9413 4.83011 17.8676 4.58128 17.6687C4.07009 17.2598 3.84231 16.7273 3.96033 16.0718C4.04152 15.6218 4.16556 15.1803 4.27269 14.7264H12.7341C12.8299 15.3515 13.1547 15.9405 13.0532 16.6021C12.9386 17.3493 12.4198 17.8523 11.6846 17.9701C11.6482 17.9759 11.6132 17.9901 11.5771 18.0005H5.42738V18.0001Z",
    fill: "#22D758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7322 13.0861C12.6612 13.0861 12.5991 13.0861 12.5371 13.0861C9.84959 13.0861 7.16207 13.085 4.47454 13.0896C4.31892 13.0896 4.25164 13.0543 4.21368 12.8857C3.87313 11.3779 3.69873 9.85436 3.8175 8.30739C4.04002 5.41234 5.06279 2.88742 7.17034 0.8797C7.43007 0.632431 7.71461 0.410502 7.99802 0.190878C8.33142 -0.0679105 8.6746 -0.0602313 9.01702 0.194718C10.3473 1.18533 11.3531 2.45009 12.0692 3.96059C12.9551 5.82855 13.2938 7.80555 13.2051 9.86895C13.1607 10.8987 13.013 11.9128 12.7796 12.9145C12.7668 12.9694 12.7499 13.0232 12.7322 13.0865V13.0861ZM9.7015 6.95739C9.70375 6.27663 9.16888 5.72987 8.50207 5.73102C7.83376 5.73217 7.30189 6.27624 7.30264 6.95777C7.3034 7.62356 7.83977 8.17492 8.49267 8.18107C9.15121 8.18721 9.69924 7.63239 9.7015 6.95777V6.95739Z",
    fill: "#22D758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73497 13.6394C2.29407 13.7293 1.88135 13.836 1.46225 13.8932C0.900311 13.97 0.507895 13.5972 0.506015 13.0174C0.504136 12.4173 0.488725 11.8164 0.51466 11.2178C0.573297 9.8578 1.11607 8.72128 2.09184 7.79824C2.13131 7.761 2.17567 7.72951 2.25798 7.66309C2.07305 9.70536 2.22378 11.6758 2.73535 13.6398L2.73497 13.6394Z",
    fill: "#22D758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2692 13.6394C14.7789 11.6789 14.9281 9.71417 14.7458 7.67688C15.1307 7.99057 15.4205 8.32615 15.6678 8.70051C16.2211 9.53716 16.4992 10.4614 16.4985 11.4719C16.4985 11.9887 16.5011 12.5052 16.4977 13.022C16.4944 13.5945 16.1162 13.9619 15.5565 13.8928C15.1314 13.8402 14.7134 13.7292 14.2684 13.6394H14.2692Z",
    fill: "#22D758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.0d0f9d1b.svg";
export { ForwardRef as ReactComponent };